import React from 'react'
import AdminPortalDashboard from './adminPortalDashboard'
import { ControlLabel, FormControl } from 'react-bootstrap'
import ParentPortal from './parentPortal'
import { getParams, end_point } from './helper'

var $ = require('jquery')


class Portals extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      token: getParams().jwt,
      organization_id: getParams().organization_id || localStorage.getItem('organization_id'),
      organizations: [],
      athletes: [],
      programs: [],
      portalMode: null
    };
    this.organizationSelected = this.organizationSelected.bind(this);
    }

  componentDidMount() {
    var rthis = this;
    $.ajax({
        headers: {
          "token": this.state.token
        },
        method: "GET",
        dataType: "json",
        url: `${end_point()}/portal`,
        success: function (data) {
          if (data && data.errorMessage) {
            alert(data.errorMessage);
          } else {
            console.log('results from portal:', data.message)
            rthis.portalGetHandler(data.message);                    
          }
        },
        error: function (data){
          window.alert("Please contact support")
        }
    })
  }

    organizationSelected(selection){
      localStorage.setItem("organization_id", selection.target.value)
      this.setState({organization_id: selection.target.value});
    }


    portalGetHandler(resp){
      console.log('in portalGetHandler', resp)
      var portalMode = null;
        if(getParams().portalMode){
          portalMode = getParams().portalMode
        } else {
          portalMode = resp.type
        }
        if (resp.errorMessage) {
          alert(resp.errorMessage);
          window.location.href = document.location.origin + "/login";
        } else {
            if(typeof this.state.organization_id !== "undefined"){
                localStorage.setItem("organization_id", this.state.organization_id)
                this.setState({ portalMode: portalMode})
            }
            //if one organization id, set the state
            else if(resp.organizations.length === 1){
                localStorage.setItem("organization_id", resp.organizations[0]._id)
                this.setState({portalMode: portalMode, organization_id: resp.organizations[0]._id})
            }
            //if more than one make selector visible
            else if(resp.organizations.length > 1) {
              if (resp.type === "admin") {
                // when admins/orgs are created through EF2, admins have access to the league's org with admin rights. This will only allow them to see their own org.
                this.setState({portalMode: portalMode, organization_id: resp.current_user.organization_ids[0]})
              }
              console.log('multiple orgs found - ', resp.organizations)
                if( this.state.organization_id ){
                  localStorage.setItem("organization_id", this.state.organization_id)
                }
                this.setState({portalMode: portalMode, organizations: resp.organizations})
            }
            //if none send back to login
            else{
              alert("account is not connected to an organization, please contact support");
              window.location.href = document.location.origin + "/login";
            }
        }
    }

    
    render() {
        const { portalMode, organization_id, organizations } = this.state
        console.log("portalMode:", portalMode, "organization_id", organization_id, organizations.length)
        var orgs = [];

        organizations.forEach((organization) => {
          orgs.push(<option value={organization._id}>{organization.name}</option>)
        })
        var portalContents = <div className="full-page"><div className="loader cent"></div></div>
        if(!organization_id && organizations.length > 1 && portalMode === "parent"){
            portalContents = <div className="full-page">
                <ControlLabel className="white-text">Please select which organization you wish to sign in to:</ControlLabel>
                <FormControl className="opaque-grey" id="selected_organization" onChange={this.organizationSelected.bind(this)} componentClass="select">
                    <option value="" selected disabled>---</option>
                    {orgs}
                </FormControl>
            </div>
        }
        else if (portalMode === "parent") {
          portalContents = <ParentPortal organization_id={organization_id}/>
        }
        else if (portalMode === "manager") {
          window.location.href = document.location.origin + "/programs2?jwt=" + this.state.token
        }
        else if (portalMode === "admin") {
            portalContents = <AdminPortalDashboard/>
        }
        else if (portalMode === "coach") {
          portalContents = <ParentPortal organization_id={organization_id}/>
            //window.location.href = document.location.origin + "/programRosters?jwt=" + this.state.token +"&type=coach"
        }

        return (portalContents)
        // return (<AdminPortalDashboard />)
    }
}

export default Portals;
